<template>
  <v-data-table :headers="headers" :items="turmas" :sort-desc="true" class="elevation-1" :search="search">
    <template v-slot:top>
      <v-progress-circular :size="50" color="green" indeterminate v-if="isLoading"></v-progress-circular>
      <v-toolbar flat color="white">

        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>

        <v-divider class="mx-8" inset vertical></v-divider>
        <span>Selecionado : <strong style="font-size:22px;">{{ $store.state.novadescricaoSelecionado }}</strong></span>

        <div class="flex-grow-1"></div>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon class="mr-2" @click=" disciplinasDaTurma(item)" style="color:green">list</v-icon>
    </template>
    <template v-slot:no-data>
      Dados não encontrados!
    </template>
  </v-data-table>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
import Swal from 'sweetalert2'
export default {
  data: () => ({
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    disciplinas: [],
    notas: [],
    isLoading: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    periodos: [
      { descricao: 'Manhã', value: 'M' },
      { descricao: 'Tarde', value: 'T' }
    ],
    turmas: [],
    dialog: false,
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    defaultItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    turmasProfessor: []
  }),

  computed: {
    idclasse() {
      return this.$store.state.idclasse
    },
    classeTur() {
      return this.$store.state.classeTur
    },
    nivelUsuario() {
      return ls.get('nivel_user')
    },
    idPessoa() {
      return ls.get('idPessoa')
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initializeturmasAll()
  },

  methods: {
    disciplinasDaTurma(dados) {
      let turma = {
        anoLectivo: dados.anoLectivo,
        idCurso: dados.idCurso,
        pkTurma: dados.pkTurma,
        idclasse: dados.idAno_Academico,
        periodo: dados.periodo,
        turma: dados.turmadescricao,
        curso: dados.curso
      }

      if (this.nivelUsuario == 6) {
        let discProf = [];
        for (let i = 0; i < this.turmasProfessor.length; i++) {
          discProf.push({iddisciplina: this.turmasProfessor[i].iddisciplina});
        }
        ls.set('disciplinasDoProfessor', discProf)
      }

      ls.set('disciplinasDaTurma', turma)
      this.$router.push('DisciplinaDaTurma')
    },


    async initializeturmasAll() {
      try {
        this.isLoading = true
        let turmasAll = await this.getAllTurmas();

        if (this.nivelUsuario == 6) {
          const idProfessor = await this.getIdProfessor();
          this.turmasProfessor = await this.getTurmasProfessor(idProfessor)
          this.turmas = turmasAll.filter(turma => this.turmasProfessor.some(turmaProf => turmaProf.fkTurma == turma.pkTurma));
        } else {
          this.turmas = turmasAll;
        }        
      } catch (error) {
        Swal.fire('Erro', 'Erro ao carregar as turmas!', 'error');
      } finally {
        this.isLoading = false
      }
    },

    async getAllTurmas() {
      try {
        const turmas = await axios.get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse).then(res => res.data);
        return turmas;
      } catch (error) {
        Swal.fire('Erro', 'Erro ao carregar as turmas!', 'error');
      }
    },

    async getIdProfessor() {
      try {
        const idProfessor = await axios.get(`/getIdProfessor/${this.idPessoa}`);
        return idProfessor.data[0].idProfessor;
      } catch (error) {
        Swal.fire('Erro', 'Erro ao carregar o id do professor!', 'error');
      }
    },

    async getTurmasProfessor(idProfessor) {
      try {
        const turmasProfessorAll = await axios.get(`/getTurmasProfessor/${idProfessor}/${this.$store.state.anolectivoSelecionado}`).then(res => res.data);
        return turmasProfessorAll;
      } catch (error) {
        Swal.fire('Erro', 'Erro ao caregar as turmas do professor!', 'error');
      }
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
  }
}
</script>